export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; activeMatch?: string[] }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'wechat-artist-import',
      displayName: 'menu.wechat-artist-import',
      meta: {
        icon: 'travel_explore',
        activeMatch: ['wechat-artist-import'],
      },
    },
    {
      name: 'certificates',
      displayName: 'menu.certificates',
      meta: {
        icon: 'workspace_premium',
        activeMatch: ['certificates-list', 'certificates-add', 'certificates-edit'],
      },
      children: [
        {
          name: 'certificates-list',
          displayName: 'menu.certificates-list',
          meta: {
            icon: 'list',
            activeMatch: ['certificates-list', 'certificates-add', 'certificates-edit'],
          },
        },
      ],
    },
    {
      name: 'website-members',
      displayName: 'menu.website-members',
      meta: {
        icon: 'language',
        activeMatch: ['website-members-list', 'website-members-add', 'website-members-edit'],
      },
      children: [
        {
          name: 'website-members-list',
          displayName: 'menu.website-members-list',
          meta: {
            icon: 'list',
            activeMatch: ['website-members-list', 'website-members-add', 'website-members-edit'],
          },
        },
      ],
    },
    {
      name: 'artworks',
      displayName: 'menu.artworks',
      meta: {
        icon: 'image',
        activeMatch: ['artworks-list', 'artworks-add', 'artworks-edit', 'artwork-reservations'],
      },
      children: [
        {
          name: 'artworks-list',
          displayName: 'menu.artworks-list',
          meta: {
            icon: 'list',
            activeMatch: ['artworks-list', 'artworks-add', 'artworks-edit'],
          },
        },
        {
          name: 'artwork-reservations',
          displayName: 'menu.artwork-reservations',
          meta: {
            icon: 'event_available',
            activeMatch: ['artwork-reservations'],
          },
        },
      ],
    },
    {
      name: 'cms-pages',
      displayName: 'menu.cms',
      meta: {
        icon: 'palette',
        activeMatch: ['cms-pages-list', 'cms-add', 'cms-pages-edit', 'icaa-team'],
      },
      children: [
        {
          name: 'cms-pages-list',
          displayName: 'menu.cms-list',
          meta: {
            icon: 'list',
            activeMatch: ['cms-pages-list', 'cms-add', 'cms-pages-edit'],
          },
        },
        {
          name: 'icaa-team',
          displayName: 'menu.icaa-team',
          meta: {
            icon: 'groups',
            activeMatch: ['icaa-team'],
          },
        },
      ],
    },
    {
      name: 'blog',
      displayName: 'menu.blog',
      meta: {
        icon: 'article',
        activeMatch: [
          'blog-articles-list',
          'blog-articles-add',
          'blog-articles-edit',
          'blog-categories-list',
          'blog-categories-add',
          'blog-categories-edit',
          'blog-tags-list',
          'blog-tags-add',
          'blog-tags-edit',
        ],
      },
      children: [
        {
          name: 'blog-articles-list',
          displayName: 'menu.blog-articles-list',
          meta: {
            icon: 'list',
            activeMatch: ['blog-articles-list', 'blog-articles-add', 'blog-articles-edit'],
          },
        },
        {
          name: 'blog-categories-list',
          displayName: 'menu.blog-categories-list',
          meta: {
            icon: 'folder',
            activeMatch: ['blog-categories-list', 'blog-categories-add', 'blog-categories-edit'],
          },
        },
        {
          name: 'blog-tags-list',
          displayName: 'menu.blog-tags-list',
          meta: {
            icon: 'sell',
            activeMatch: ['blog-tags-list', 'blog-tags-add', 'blog-tags-edit'],
          },
        },
      ],
    },
  ] as INavigationRoute[],
}
